import { gql, useQuery } from '@apollo/client';
import {
  Box,
  Button,
  ButtonProps,
  Menu,
  MenuButton,
  MenuList,
  Portal,
} from '@chakra-ui/react';
import * as React from 'react';

import { useCurrent } from '@/hooks/useCurrent';
import { useGetAbsoluteUrl } from '@/imports/ui/hooks/useGetAbsoluteUrl';

import {
  AddToCalendarMenu_Event,
  AddToCalendarMenu_EventVariables,
} from './graphql-types/AddToCalendarMenu_Event';

import { AddToCalendarMenuItems } from './components/AddToCalendarMenuItems';

const EVENT_QUERY = gql`
  query AddToCalendarMenu_Event(
    $input: EventInput!
    $conferenceSessionsInput: ConferenceEvent_SessionsInput!
  ) {
    event(input: $input) {
      eventV2 {
        _id
        ...AddToCalendarMenuItems_EventFragment
      }
    }
  }
  ${AddToCalendarMenuItems.eventFragment}
`;

export const AddToCalendarMenu: React.FC<{ eventId: string } & ButtonProps> = ({
  eventId,
  ...buttonProps
}) => {
  const { getAbsoluteUrl } = useGetAbsoluteUrl();
  const current = useCurrent();
  const absoluteUrl = getAbsoluteUrl ? getAbsoluteUrl() : undefined;
  const query = useQuery<
    AddToCalendarMenu_Event,
    AddToCalendarMenu_EventVariables
  >(EVENT_QUERY, {
    variables: {
      input: { _id: eventId },
      conferenceSessionsInput: {
        // Todo (Flo): this is not great
        limit: 100,
        offset: 0,
      },
    },
  });

  if (query.loading || current.loading) {
    return null;
  }

  if (
    query.error ||
    !absoluteUrl ||
    !current.tenant?.displayName ||
    !query.data?.event.eventV2
  ) {
    return null;
  }

  return (
    <Box>
      <Menu isLazy>
        <MenuButton
          as={Button}
          variant="link"
          colorScheme="black"
          {...buttonProps}
        >
          Add to Calendar
        </MenuButton>
        <Portal>
          <MenuList>
            <AddToCalendarMenuItems
              communityName={current.tenant.displayName}
              hostnameAndProtocol={absoluteUrl}
              event={query.data.event.eventV2}
            />
          </MenuList>
        </Portal>
      </Menu>
    </Box>
  );
};
